var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container",attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":"https://www.google.com/maps/d/viewer?mid=1CF2gk6YW4TsPNqHf1ih5y5AaAv6zHP2k&ll=47.14964031784158%2C-93.88052554999999&z=4","width":"100%","height":"800"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }